import { render } from "./OurLatestBlog.vue?vue&type=template&id=7e3238c6&scoped=true&ts=true"
import script from "./OurLatestBlog.vue?vue&type=script&lang=ts"
export * from "./OurLatestBlog.vue?vue&type=script&lang=ts"

import "./OurLatestBlog.vue?vue&type=style&index=0&id=7e3238c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3238c6"]])

export default __exports__